import React, { useEffect, useMemo, } from 'react'
import { useOrganization } from '../contexts/OrganizationContext'
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import AzureCompanyPicker from '../components/AzureCompanyPicker';
import AzureCustomerPicker from '../components/AzureCustomerPicker';
import AzureItemPicker from '../components/AzureItemPicker';
import { AdvancedButton } from '../components/AdvancedButton';
import { toast } from 'react-toastify';
import { doc, setDoc } from 'firebase/firestore';
import { useFirestore } from 'reactfire';
import { COLLECTIONS } from '../utils/shared/constants';

interface MappingState {
    azureCompanyId?: string;
    azureCustomerId?: string;
    azureCustomerName?: string;
    azureItemId?: string;
}
export default function GoodsOwnerSettingsPage() {
    const navigate = useNavigate();
    const { ix } = useParams<{ ix: string }>();
    const organization = useOrganization();
    const [state, setState] = React.useState<MappingState>({});
    const firestore = useFirestore();
    const [processing, setProcessing] = React.useState(false);

    const goodsOwner = useMemo(() => organization.goodsOwners[parseInt(ix || '0')], [ix, organization.goodsOwners]);

    useEffect(() => {
        setState({
            azureCompanyId: goodsOwner.azureCompanyId,
            azureCustomerId: goodsOwner.azureCustomerId,
            azureCustomerName: goodsOwner.azureCustomerName,
            azureItemId: goodsOwner.azureItemId,
        });
    }, [goodsOwner]);


    const handleSave = async () => {
        setProcessing(true);

        if (!state.azureCompanyId) {
            toast.error('Please select a Business Centrum company.');
            return;
        }

        if (!state.azureCustomerId) {
            toast.error('Please select a Business Centrum customer.');
            return;
        }

        if (!state.azureItemId) {
            toast.error('Please select a Business Centrum item.');
            return;
        }

        const updatedGoodsOwner = {
            ...goodsOwner,
            azureCompanyId: state.azureCompanyId,
            azureCustomerId: state.azureCustomerId,
            azureCustomerName: state.azureCustomerName,
            azureItemId: state.azureItemId,
        };

        const newGoodsOwners = [...organization.goodsOwners];
        newGoodsOwners[parseInt(ix || '0')] = updatedGoodsOwner;

        try {

            const orgRef = doc(firestore, `${COLLECTIONS.ORGANIZATIONS}/${organization.id}`);
            await setDoc(orgRef, { goodsOwners: newGoodsOwners }, { merge: true });


            toast.success('Goods owner settings updated successfully.');
        } catch (error) {
            console.error('Failed to update goods owner settings:', error);
            toast.error('Failed to update goods owner settings. Please try again later.');
        }
        setProcessing(false);
    }


    return (
        <div>
            <PageHeader title={`Settings for - ${goodsOwner.name}`} showBackButton
                description={"Manage Business Centrum mapping and for this goods owner."}
            />

            <div className='d-flex flex-column gap-3'>

                <AzureCompanyPicker companyId={state.azureCompanyId || ''} onChange={(companyId) => setState(prev => ({ ...prev, azureCompanyId: companyId }))} />

                <AzureCustomerPicker companyId={state.azureCompanyId || ''} customerId={state.azureCustomerId || ''}
                    onChange={(customerId, customerName) => setState(prev => ({ ...prev, azureCustomerId: customerId, azureCustomerName: customerName }))} />

                <AzureItemPicker companyId={state.azureCompanyId || ''} itemId={state.azureItemId || ''}
                    onChange={(itemId) => setState(prev => ({ ...prev, azureItemId: itemId }))} />
            </div>

            <div className='d-flex justify-content-end gap-2 mt-3'>
                <AdvancedButton variant='secondary' onClick={() => navigate(-1)}>Cancel</AdvancedButton>
                <AdvancedButton processing={processing} icon='bi-floppy' variant='primary' onClick={handleSave}>Save</AdvancedButton>
            </div>
        </div>
    )
}
